import agent from "../api/agent";

export interface Outlet {
  id: number;
  name: string;
  created_at: string;
  email: string;
  mobile: string;
  pan_number: string;
  gst_number: string;
  stateid?: string;
  shipping_addressline1: string;
  shippingpincode: string;
  shippingcity: string;
  billing_addressline1?: string;
  billingpincode?: string;
  billingcity?: string;
  shippingState?: {
    id: number;
    name: string;
  };
  org_id?: number; // Keep org_id for mapping
  organisation?: {
    // Optional because backend might not send it
    id: number;
    name: string;
  };
}

export interface OutletFilters {
  startDate?: string;
  endDate?: string;
  statusId?: number | "";
  orderId?: string;
  stateId?: number | "";
}


export const fetchOutlet = async (filters?: OutletFilters): Promise<any> => {
  const params: Record<string, string> = {};

  if (filters?.startDate) params.start_date = filters.startDate;
  if (filters?.endDate) params.end_date = filters.endDate;
  if (filters?.statusId !== "" && filters?.statusId !== undefined)
    params.status_id = filters.statusId.toString();
  if (filters?.orderId) params.order_id = filters.orderId;
  if (filters?.stateId !== "" && filters?.stateId !== undefined)
    params.state_id = filters.stateId.toString();

  const response = await agent.Outlet.get({ params });
  return response;
};

export const fetchOutletList = async (): Promise<any> => {
  return await agent.Outlet.get();
};

export const addOutlet = async (data: any): Promise<any> => {
  return await agent.Outlet.create(data);
};

export const fetchOutletByOrganisation = async (
  org_id: number
): Promise<any> => {
  return await agent.Outlet.getByOrganisation(org_id);
};

export const deleteOutlet = async (id: number): Promise<any> => {
  const response = await agent.Outlet.delete(id);
  return response.data;
};

export const getOutletById = async (id: number): Promise<any> => {
  return await agent.Outlet.getById(id);
};

export const updateOutlet = async (data: any, id: number): Promise<any> => {
  return await agent.Outlet.updateOutlet(data, id);
};
